import { setItem } from "owa-local-storage";
import { getRecentBuildings, setRecentBuildings } from "../store";
import { getBuildingCacheKey } from "./getBuildingCacheKey";
export function removeInvalidBuildingCache(buildingId: string): void {
    const newRecentBuildingArray = [...(getRecentBuildings() ?? [])];
    const index = newRecentBuildingArray.indexOf(buildingId);
    // If the invalid buildingId exists in the array, remove it
    if (index !== -1) {
        newRecentBuildingArray.splice(index, 1);
        const serializedArray = JSON.stringify(newRecentBuildingArray);
        setItem(window, getBuildingCacheKey(), serializedArray);
        // update the store
        setRecentBuildings(newRecentBuildingArray);
    }
}
